import React from 'react';
import logo from '../assets/images/logo_transparent_cut_landscape.png';
import badge from '../assets/images/logo_transparent_cut.png';
import '../assets/style/brand-wordmark.css';

export default function BrandWordmark({ compact = false, inverse = false, large = false }) {
 return <img src={compact ? badge : logo} alt="Viblica" width={compact ? 1280 : 1200} height={compact ? 1280 : 737} className={`viblica-wordmark${compact?' viblica-wordmark-compact':''}${inverse?' viblica-wordmark-inverse':''}${large?' viblica-wordmark-large':''}`} />;
}
